if (!customElements.get("highlight-selector")) {
    class HighlightSelector extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // Initialisieren und das Highlight verschieben, wenn ein Radio-Button ausgewählt wird
            const inputs = this.querySelectorAll('input[name="bundle-variant"]');
            const contents = this.querySelectorAll(".highlight-content")
            // Anzahl der Varianten und Breite der Highlight-Pille berechnen
            const variantCount = inputs.length;
            // Setze die Gesamtanzahl als CSS-Variable (falls gebraucht)
            this.style.setProperty('--variant-count', variantCount);

            // Event-Listener für jede Input-Option
            inputs.forEach((input, index) => {
                input.addEventListener('change', () => {
                    // Verschiebe die Highlight-Pille
                    this.style.setProperty('--highlight-transform', `${index * 100}%`);

                    // Inhalt ein-/ausblenden basierend auf der Auswahl
                    contents.forEach((contentDiv, contentIndex) => {
                        if (contentIndex == index) {
                            contentDiv.classList.add("active")
                        }
                        else {
                            contentDiv.classList.remove("active")
                        }
                    });
                });
            });
        }
    }

    customElements.define("highlight-selector", HighlightSelector);
}

if (!customElements.get("bundle-builder-popup")) {
    class BundleBuilderPopup extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.collection_selector = this.querySelector(".popup--collection-selector")
            this.collection_selector.addEventListener("change", this.changeCollection.bind(this))
            this.collection_contents = this.querySelectorAll(".popup-collection--products-wrapper")
            this.collections = this.querySelectorAll(".popup-collection--content");
            this.collections.forEach(collection => {
                this.observeCollection(collection)
            })
            this.bundle_builder = this.closest("bundle-builder")
            this.addEventListener("click", this.handleOverlayClick.bind(this))
        }
        handleOverlayClick(event) {
            if (!event.target.closest(".bundle-builder--selector-popup")) {
                this.close()
            }
        }
        updateCollections() {
            this.collections = this.querySelectorAll(".popup-collection--content");
        }
        changeCollection(event) {
            if (event.target && event.target.dataset.collection != "") {
                const activeElement = Array.from(this.collections).find((element) =>
                    element.classList.contains('active')
                );
                const newActiveElement = Array.from(this.collections).find((element) =>
                    element.dataset.collectionId == event.target.dataset.collectionId
                );
                if (activeElement && newActiveElement) {
                    activeElement.classList.remove("active")
                    newActiveElement.classList.add("active")
                    this.updateCollections()
                }
            }
        }
        nextCollection() {
            // Alle Inputs in der .popup-collection-selector in ein Array speichern
            let inputs = this.querySelectorAll(".popup--collection-selector input");
            inputs = Array.from(inputs)
            // Finde den aktuell ausgewählten Input (input:checked)
            const currentIndex = inputs.findIndex(input => input.checked);
            console.log(currentIndex, inputs.length)
            // Prüfen, ob der aktuelle Input der letzte ist
            if (currentIndex === inputs.length - 1) {
                // Der aktuelle ist der letzte, `this.close` ausführen
                console.log("Letzter Input erreicht. Schließe...");
                this.close();
            } else {
                // Anderenfalls, den nächsten Input auswählen
                const nextInput = inputs[currentIndex + 1];
                console.log(nextInput)
                if (nextInput) {
                    nextInput.checked = true; // Wähle den nächsten Input
                    nextInput.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change-Event
                    console.log("Nächster Input ausgewählt:", nextInput);
                }
            }
        }
        observeCollection(collection) {
            const button = collection.querySelector(".product-select--button");

            // Sicherstellen, dass ein Button existiert
            if (!button) {
                console.error("Button nicht gefunden in:", collection);
                return;
            }

            // Change-Listener auf die Collection setzen
            collection.addEventListener("change", (event) => {
                // Prüfen, ob das Event von einem Radio-Input stammt
                if (event.target && event.target.type === "radio") {
                    button.removeAttribute("disabled");
                    this.changeProduct(collection)
                }
            });

            // Initialprüfung: Falls bereits ein Radio-Input ausgewählt ist
            const checkedInput = collection.querySelector("input[type='radio']:checked");
            if (checkedInput) {
                button.removeAttribute("disabled");
            }
        }
        close() {
            this.classList.remove("open")
        }
        open() {
            let first_input = this.querySelector(".popup--collection-selector input");
            if (!first_input.checked) {
                first_input.checked = true
                first_input.dispatchEvent(new Event("change", { bubbles: true }))
            }
            this.classList.add("open")
        }
        openCollectionById(collection_id) {
            let input = this.querySelector(`.popup--collection-selector input[data-collection-id="${collection_id}"]`)
            // console.log("obenById", input)
            if (input) {
                input.checked = true; // Wähle den nächsten Input
                input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change-Event
                this.classList.add("open")
            }
        }
        changeProduct(collection) {
            let selected_variant = collection.querySelector(".bundle-builder--product-card-wrapper:has(input:checked)")
            let collection_id = collection.dataset.collectionId
            // console.log("COLLECTION", collection, collection_id,selected_variant.dataset)
            let product_id = selected_variant.dataset.productId
            let product_url = selected_variant.dataset.productUrl
            let variant_id = selected_variant.dataset.variantId
            let place_holders = this.bundle_builder.querySelectorAll(`.bundle-content--product[data-collection-id="${collection_id}"]`)
            place_holders.forEach(place_holder => {
                place_holder.setAttribute("selected-product", product_id)
                place_holder.innerHTML = selected_variant.querySelector(".bundle-builder--product").innerHTML

            })

            this.synchPopupInputs(product_id, collection_id)

            this.bundle_builder.addProduct(product_id, collection_id)
            this.bundle_builder.addNewProductToHtmlArray(product_id,product_url)
        }
        synchPopupInputs(product_id, collection_id) {
            // console.log("synch Inputs", this.bundle_builder, product_id, collection_id)
            let inputs = this.bundle_builder.querySelectorAll(`.bundle-builder--product-selector[data-collection-id="${collection_id}"][data-product-id="${product_id}"]`)
            // console.log(inputs)
            inputs.forEach(input => {
                input.checked = true
                let collection = input.closest(".popup-collection--content")
                if (collection) collection.querySelector(".product-select--button")?.removeAttribute("disabled")
            })
        }

    }
    customElements.define("bundle-builder-popup", BundleBuilderPopup);
}

if (!customElements.get("next-collection-btn")) {
    class nextCollectionButton extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.addEventListener("click", this.closest("bundle-builder-popup").nextCollection.bind(this.closest("bundle-builder-popup")))
        }
    }
    customElements.define("next-collection-btn", nextCollectionButton);
}

if (!customElements.get("bundle-builder")) {
    class BundleBuilder extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.miniCart = document.querySelector('mini-cart');
            this.product_id = this.dataset.productId
            this.querySelector(".open-popup-btn").addEventListener("click", this.choseProducts.bind(this));
            this.active_content = this.querySelector(".highlight-content.active");
            this.initBundleJson();
            this.initVariantHandler();
            this.initContentOnclicks();
            this.form = this.querySelector("form")
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
            this.initBundleVariants()
            this.fetchedProducts={}
        }

        initBundleJson() {
            let bundleJSON = {};
            let variant_elements = this.querySelectorAll(".bundle-variant-content");

            if (variant_elements.length) {
                variant_elements.forEach(var_element => {
                    let index = var_element.dataset.index;
                    bundleJSON[index] = {};

                    let collection_elements = var_element.querySelectorAll(".bundle-collection-content");
                    if (collection_elements.length) {
                        collection_elements.forEach(col_element => {
                            let collection_id = col_element.dataset.collectionId;
                            bundleJSON[index][collection_id] = null;
                        });
                    }
                });
            }

            this.bundleJSON = bundleJSON;
            // console.log("Initialized bundleJSON:", this.bundleJSON);
        }

        initVariantHandler() {
            this.active_index = this.querySelector(".bundle-selector--wrapper input:checked")?.dataset.index;
            this.variant_select = this.querySelector(".bundle-selector--wrapper");

            this.updateSubmitButtonState(); // Initial Check

            this.variant_select.addEventListener("change", (event) => {
                if (event.target && event.target.type === "radio" && event.target.dataset.index) {
                    this.active_index = event.target.dataset.index;
                    this.updateAccordionContent()
                    this.updateSubmitButtonState();
                }
            });
        }

        initContentOnclicks() {
            let content_elements = this.querySelectorAll(".bundle-content--product");
            content_elements.forEach(content_element => {
                if (content_element.dataset.collectionId && content_element.dataset.collectionId !== "") {
                    content_element.addEventListener("click", this.handleContentOnclick.bind(this));
                }
            });
        }
        handleContentOnclick(event) {
            let collection_id = event.target.closest(".bundle-content--product")?.dataset.collectionId;
            let product_url = event.target.closest(".bundle-content--product")?.dataset.productUrl;
            let product_id = event.target.closest(".bundle-content--product")?.dataset.productId;
            if (this.active_index && collection_id) {
                let popup = this.querySelector(`bundle-builder-popup[data-index="${this.active_index}"]`);
                if (popup) popup.openCollectionById(collection_id);
            }
            this.addNewProductToHtmlArray(product_id, product_url)
            
        }
        updateAccordionContent() {
            // console.log("FIRE!",this.bundleJSON[this.active_index])
            // Get the array of product IDs for the active index
            const ID_ARRAY = Object.values(this.bundleJSON[this.active_index] || {});
        
            if(this.fetchedProducts == {} || this.fetchedProducts == undefined ){return}
            // Iterate through each product ID
            ID_ARRAY.forEach((id) => {
                // console.log("id",id)
                const HTML_CONTENT = this.fetchedProducts[id];
                if (!HTML_CONTENT) {
                    return; // Skip if no HTML content is available
                }
                
                // Parse HTML_CONTENT into a DOM structure
                const parser = new DOMParser();
                const doc = parser.parseFromString(HTML_CONTENT, "text/html");
        
                // Find accordions in the fetched content
                const HTML_ACCORDIONS = doc.querySelectorAll(".product accordion-tab");
                if (!HTML_ACCORDIONS.length) {
                    console.warn(`No accordions found in fetched content for product ID: ${id}`);
                    return;
                }
                
                // Update accordions on the current page
                const currentPageAccordions = this.closest("section")?.querySelectorAll("accordion-tab") || [];
                const currentPageAccordionsText = this.closest("section")?.querySelectorAll("accordion-tab.product__accordion [data-bundle-product-id]") || [];
                const currentPageDubText = this.closest("section")?.querySelectorAll(`accordion-tab.product__accordion [data-bundle-product-id="${id}"]`) || [];
                

                currentPageAccordionsText.forEach(div => {
                    const foundId = ID_ARRAY.find(id => id == div.dataset.bundleProductId);
                    // console.log("foundId", foundId, ID_ARRAY)
                    if (!foundId) {
                    // console.log("Removing div with ID: " + div.dataset.bundleProductId);
                        div.remove(); // Removing the div if not found in ID_ARRAY
                    }
                });


                if(currentPageDubText.length>0){return}

                currentPageAccordions.forEach((accordion) => {
                    const currentTitle = accordion.querySelector(".accordion__title")?.innerHTML.trim();
                    if (!currentTitle) return;
        
                    // Add all matching content to the accordion
                    HTML_ACCORDIONS.forEach((pdpContent) => {
                        const pdpTitle = pdpContent.querySelector(".accordion__title")?.innerHTML.trim();
                        if (pdpTitle === currentTitle) {
                            const pdpContentBody = pdpContent.querySelector(".accordion__content");
        
                            // Add a wrapper using data attributes
                            const wrapper = document.createElement("div");
                            wrapper.setAttribute("data-bundle-product-id", id);
                            wrapper.innerHTML = `
                                <p><strong>${doc.querySelector(".product__title")?.innerHTML || ""}</strong></p>
                                ${pdpContentBody.innerHTML}
                            `;

                            // Avoid duplicates
                            const existingWrapper = accordion.querySelector(`.accordion__content [data-bundle-product-id="${id}"]`);
                            if (!existingWrapper) {
                                accordion.querySelector(".accordion__content").appendChild(wrapper);
                            }
                        }
                    });
                });
            });
        }
         
        async fetchProductHTML(product_id, product_url) {
            try {
                const response = await fetch(product_url);
                if (!response.ok) {
                    throw new Error(`Failed to fetch product HTML for ID ${product_id}`);
                }
                return await response.text(); // Return HTML as a string
            } catch (error) {
                console.error(`Error fetching product HTML: ${error.message}`);
                return null;
            }
        }
        choseProducts(event) {
            event.preventDefault();
            if (this.active_index) {
                let popup = this.querySelector(`bundle-builder-popup[data-index="${this.active_index}"]`);
                if (popup) popup.open();
            }
        }
        addProduct(product_id_to_add, collection_id) {
            if (!this.bundleJSON) {
                this.initBundleJson();
                if (!this.bundleJSON) {
                    console.error("Bundle JSON is not initialized.");
                    return;
                }
            }
            // Iteriere über alle Varianten im JSON
            Object.keys(this.bundleJSON).forEach(index => {
                if (this.bundleJSON[index][collection_id] !== undefined) {
                    // Weise die übergebene `product_id_to_add` dem Index zu
                    this.bundleJSON[index][collection_id] = product_id_to_add;
                }
            });

            this.updateSubmitButtonState(); // Update state after adding a product
            // console.log("Updated bundleJSON after addProduct:", this.bundleJSON);
        }
        async addNewProductToHtmlArray(product_id, product_url) {
            // Check if the product was already fetched
            if (this.fetchedProducts != undefined && this.fetchedProducts[product_id]) {
                // console.log(`Product ${product_id} already fetched`);
                this.updateAccordionContent()
            } else {
                // Fetch and save the product HTML
                const fetchedProduct = await this.fetchProductHTML(product_id, product_url);
                this.fetchedProducts[product_id] = fetchedProduct; // Save to cache
                this.updateAccordionContent()
            }
        }
        async updateProductPriceDisplay() {
           if(this.bundleJSON && this.active_index){
            let currentSelectedVariant = await this.findBundleVariantForSelection(Object.values(this.bundleJSON[this.active_index]));
            if (currentSelectedVariant) {
                
                // Update price display element
                const priceElements = document.querySelectorAll(".price-range");
                priceElements.forEach((ele) => {
                    const priceAmount = currentSelectedVariant.price.amount
                    const {
                        currencyCode
                    } = currentSelectedVariant.price
                    const compareAtPriceAmount = currentSelectedVariant.compareAtPrice?.amount
                    let priceHTML = ''
                    const numPrice = Number(priceAmount)
                    
                    const numCompareAtPrice = compareAtPriceAmount ? Number(compareAtPriceAmount) : null
                    const formattedPrice = this.formatPrice(priceAmount,currencyCode)
                    if(numCompareAtPrice != null && numCompareAtPrice > numPrice) {    
                    // console.log("TRUE")

                        const formattedCompareAtPrice = this.formatPrice(compareAtPriceAmount,currencyCode)
                        priceHTML = `
                        <div class="price price--on-sale">
                            <div class="price__sale">
                                <dd>
                                    <s class="price-item price-item--regular">
                                        <price-money><bdi>${formattedCompareAtPrice}</bdi></price-money>
                                    </s>
                                </dd>
                                <dd>
                                    <span class="price-item price-item--sale">
                                        <price-money><bdi>${formattedPrice}</bdi></price-money>
                                    </span>
                                </dd>
                            </div>
                        </div>
                        `
                    } else {
                        priceHTML = `
                        <div class="price price--medium">
                            <dl>
                                <div class="price__regular">
                                    <dd> 
                                        <span class="price-item price-item--regular">
                                            <price-money><bdi>${formattedPrice}</bdi></price-money>
                                        </span>
                                    </dd>
                                </div>                
                            </dl>
                        </div>
                      `;
                    }
                    ele.innerHTML = priceHTML;
                });
                
            }}
        }

        getCurrency(currencyCode) {
            switch(currencyCode) {
                case 'EUR':
                    return '€';
                default:
                    return currencyCode;
            }
        }
        formatPrice(amount,currencyCode){
            const currency = this.getCurrency(currencyCode)
           if(currencyCode == "EUR"){
            amount = amount.replace(".",",")
           }
           return currency + amount
        }

        updateSubmitButtonState() {
            const submitButton = this.querySelector(".bundle-builder--atc-wrapper");
            const popupButton = this.querySelector(".open-popup-btn");

            if (this.active_index && this.bundleJSON[this.active_index]) {
                const allSelected = Object.values(this.bundleJSON[this.active_index]).every(value => value !== null);
                // console.log(allSelected, this.bundleJSON[this.active_index])
                // check if all products are selected
                if (allSelected) {
                    submitButton.classList.remove("hidden");
                    popupButton.classList.add("hidden");
                    // updates to the current price
                    this.updateProductPriceDisplay()
                    // updates the selected image
                    this.updateMediaSelection()
                } else {
                    submitButton.classList.add("hidden");
                    popupButton.classList.remove("hidden");
                }
                this.updateAccordionContent()
            }
        }
        async onSubmitHandler(event) {
            event.preventDefault()
            let products = []
            if (this.bundleJSON[this.active_index]) {
                Object.keys(this.bundleJSON[this.active_index]).forEach((collection) => {
                    products.push(this.bundleJSON[this.active_index][collection])
                })
            }
            let bundle_product_variant = await this.findBundleVariantForSelection(products)
            if (bundle_product_variant) {


                let add_object = {
                    id: null,
                    quantity: 1
                }
                // Use Fixed Bundle Product Variant --> SPlitting in Checkout with Bundles APP
                add_object.id = bundle_product_variant.variant_to_add.value ? bundle_product_variant.variant_to_add.value.replace("gid://shopify/ProductVariant/", "") : bundle_product_variant.id.replace("gid://shopify/ProductVariant/", "")
                const quantity_input = this.querySelector(".quantity__input")
                if (quantity_input) add_object.quantity = quantity_input.value

                // console.log("add Object", add_object)
                if (add_object.id != null) {
                    if (this.miniCart) {
                        add_object.sections = this.miniCart.getSectionsToRender().map((section) => section.id);
                    }
                    add_object.sections_url = window.location.pathname

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(add_object)
                    })
                        .then((response) => response.json())
                        .then((response) => {
                            if (response.status) {
                                publish(PUB_SUB_EVENTS.cartError, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    errors: response.errors || response.description,
                                    message: response.message,
                                });
                                this.error = true;
                                return;
                            }

                            if (!this.error)
                                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: add_object.id });
                            this.error = false;

                            if (this.miniCart) {
                                this.miniCart.renderContents(response);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                }

            }


        }
        async findBundleVariantForSelection(selections) {
            if (!this.bundle_product) await this.initBundleVariants()
            if (selections && selections.length > 0 && this.bundle_product) {
                return this.bundle_product.variants.find((variant) => {
                    // Extrahiere das Metafield-Wert als Array (falls vorhanden)
                    const metafieldValue = variant.contents?.value
                        ? JSON.parse(variant.contents.value)
                        : [];
                    // console.log("metafield Value", metafieldValue)
                    // Überprüfen, ob alle IDs aus targetIds im Metafield-Wert enthalten sind
                    return selections.every((id) => metafieldValue.includes(`gid://shopify/Product/${id}`)) && selections.length == metafieldValue.length;
                });
            }
        }
        async initBundleVariants() {
            if (this.product_id) {
                const storeUrl = window.Shopify.routes.root + 'api/2024-10/graphql.json';
                const accessToken = '86a17fa4e38271b44fa2cb09771a3698';
                const query = `
              query GetProductVariants($id: ID!) {
                product(id: $id) {
                  id
                  title
                  variants(first: 20) {
                    edges {
                      node {
                        id
                        sku
                        image{
                            id
                            src
                        }
                        price {
                            amount
                            currencyCode
                          }
                        compareAtPrice{
                            amount
                            currencyCode
                        }
                        contents:metafield(namespace: "bundle", key: "contents") {
                            value
                        }
                        variant_to_add:metafield(namespace: "bundle", key: "variant_to_add" ){
                            value
                        }

                      }
                    }
                  }
                }
              }
            `;

                const variables = {
                    id: "gid://shopify/Product/" + this.product_id,
                };

                try {
                    const response = await fetch(storeUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': accessToken,
                        },
                        body: JSON.stringify({
                            query,
                            variables,
                        }),
                    });
                    // console.log("RES", response)
                    const responseData = await response.json();

                    if (!response.ok || responseData.errors) {
                        throw new Error(
                            responseData.errors
                                ? responseData.errors.map((err) => err.message).join(', ')
                                : 'Failed to fetch product data.'
                        );
                    }

                    const product = responseData.data.product;

                    if (!product) {
                        throw new Error(`Product with ID ${productId} not found.`);
                    }

                    this.bundle_product = {
                        id: product.id,
                        title: product.title,
                        variants: product.variants.edges.map((edge) => edge.node),
                    };
                    console.log(this.bundle_product)
                } catch (error) {
                    console.error('Error fetching product:', error);
                    throw error;
                }
            }
        }
        async updateMediaSelection(){
            console.log("update IMage")
            const currentSelectedVariant = await this.findBundleVariantForSelection(Object.values(this.bundleJSON[this.active_index]));
            
            if(!currentSelectedVariant || !currentSelectedVariant.image.src) return
           
            const cleanedSrc = "files" + currentSelectedVariant.image.src.split("files").pop().split("?")[0]
            console.log("clened", cleanedSrc)
                const newMedia = document.querySelector(
                `[data-media-src="${this.dataset.section}-${cleanedSrc}"]`
                    );
                
                    if (!newMedia) return;
                    const mediaId = newMedia.dataset.mediaId.replace(`${this.dataset.section}-`,"")
                    const parent = newMedia.parentElement;
                    if (parent.firstChild == newMedia) return;
                    parent.prepend(newMedia);
                    parent.classList.add('product__media-no-animate');
                    if (parent.parentElement.hasOwnProperty('goToFirstSlide') && typeof parent.parentElement.goToFirstSlide === 'function') {
                    parent.parentElement.goToFirstSlide();
                    }
                
                    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
                    if (mediaGallery) {
                    const scrollIntoView = false;
                    mediaGallery.setActiveMedia(`${this.dataset.section}-${mediaId}`, true, scrollIntoView);
                    }
                
                    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
                    if (modalContent) {
                    const newMediaModal = modalContent.querySelector(`[data-media-id="${mediaId}"]`);
                    modalContent.prepend(newMediaModal);
                    }
                    
                    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
                    if (thumbnailContent) {
                    const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${mediaId}"]`);
                    thumbnailContent.prepend(newMediaThumbnail);
                    }
              


        }

    }

    customElements.define("bundle-builder", BundleBuilder);
}
